import AfterEmployeeCreationSchedulingStrategyEditor from "../../../pages/actionModules/ActionModuleEditor/SchedulingStrategyEditor/AfterEmployeeCreationSchedulingStrategyEditor";
import { SchedulingStrategyDefinition } from "../actionModule";
import { SchedulingStrategyType } from "./schedulingStrategyType";

export const AfterEmployeeCreationSchedulingStrategy: SchedulingStrategyDefinition = {
    name: "actionModules.schedulingStrategy.afterEmployeeCreation.name",
    defaultValue: {},
    type: SchedulingStrategyType.AfterEmployeeCreationSchedulingStrategy,
    editor: () => <AfterEmployeeCreationSchedulingStrategyEditor />
};